import React from 'react'
import IMAGES from "constants/images";
import { Image } from 'react-bootstrap';
import { useAuth } from 'context/UserContext';

const StepFourComponent = () => {
  const {user}=useAuth()
    // localStorage.removeItem("step");
    return (
      <div className="text-center">
        <Image src={IMAGES.Thanks_Img} className="img-fluid" alt="thanks" />
        <h3 className="mt-4 text-danger">{`${user?.firstName} ${user?.lastName || ""}`}, thanks for your review!</h3>
        <p>
          Once approved, your review will be publicly viewable on Xuthority. We
          require 3 business days to moderate all submit reviews. Thank You!
        </p>
      </div>
    );
  };

export default StepFourComponent